import { render } from "./Packages.vue?vue&type=template&id=5dedb94e&scoped=true"
import script from "./Packages.vue?vue&type=script&lang=js"
export * from "./Packages.vue?vue&type=script&lang=js"

import "./Packages.vue?vue&type=style&index=0&id=5dedb94e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dedb94e"]])

export default __exports__